import { Fragment } from 'vue-frag';
import { mapState } from 'vuex';
import { getStarsHTML } from 'utils/general';

export default {
  components: {
    Fragment,
  },
  props: ['factor', 'scores', 'products', 'isLastFactor'],
  data: () => ({
    scoresToRender: [],
  }),
  computed: {
    ...mapState('global'),
    isRating() {
      return ['rating', 'review', 'ratings', 'reviews'].includes(
        this.factor.toLowerCase(),
      );
    },
  },
  methods: {
    getStarsHTML,
    scoreContent(score, index) {
      if (this.isRating && Boolean(this.products[index])) {
        const rating = this.products[index].metafields?.yotpo?.reviews_average;

        const ratingCount =
          this.products[index].metafields?.yotpo?.reviews_count;
        if (!rating && !ratingCount) {
          return '';
        }

        return `${this.getStarsHTML(rating)} ${ratingCount} Reviews`;
      }
      return score;
    },
  },
  mounted() {
    this.scoresToRender = this.scores.split('|');
  },
  template: `
    <fragment>
      <p class="product-compare__factor" :class="{'product-compare__factor--last': isLastFactor}" v-text="factor"></p>
      <div
        class="product-compare__product-cell"
        :class="{
          'product-compare__product-cell--first': index === 0,
          'product-compare__product-cell--last': isLastFactor,
        }"
        v-for="(score, index) in scoresToRender"
      >
        <p class="product-compare__product-factor p1" v-text="factor"></p>
        <p class="product-compare__product-score p1" v-html="scoreContent(score, index)"></p>
      </div>
    </fragment>
  `,
};
